var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScalable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f7ff;}.cls-2{fill:#dcecfa;}.cls-11,.cls-12,.cls-13,.cls-14,.cls-18,.cls-19,.cls-3{fill:none;}.cls-3{stroke:#dcecfa;stroke-width:5px;}.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-18,.cls-3{stroke-miterlimit:10;}.cls-4{fill:#fd9702;}.cls-15,.cls-5{fill:#fdc666;}.cls-6{fill:#afd4f0;}.cls-7{fill:#005684;}.cls-8{fill:#f0b39c;}.cls-9{fill:#045170;}.cls-10{fill:#005681;}.cls-11{stroke:#053f54;}.cls-11,.cls-12,.cls-18{stroke-linecap:round;}.cls-11,.cls-12,.cls-13{stroke-width:0.5px;}.cls-12{stroke:#fd9702;}.cls-13,.cls-16{stroke:#fdc666;}.cls-14,.cls-15{stroke:#fff;}.cls-16,.cls-17{fill:#fff;}.cls-18{stroke:#005684;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "scalable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    d: "M143.48,486.9c-20.1,0-105.24-68.12-74.54-133.28,26.73-56.75,84.55,26,66.87-89.89C128.39,215.1,183.39,161.39,237.76,193c30.71,17.84,84.09,31.7,101.6-3.09,38-75.42,148.31-71.07,180.82,6.94C555,280.39,478,274,507.05,317.38c16.62,24.78,27.71,23.22,44.91,63.33,20.13,47-4.68,106.84-51.65,106.84Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.57,322.4l-3.42-1.21a4.14,4.14,0,0,1-2.78-4.06A32.41,32.41,0,0,0,237,310a4.15,4.15,0,0,1,2.34-4.39l3.58-1.71a4.18,4.18,0,0,0,2-5.57l-2.13-4.48a4.19,4.19,0,0,0-5.57-2l-3.8,1.8a4.22,4.22,0,0,1-4.9-.88,33.45,33.45,0,0,0-5.74-4.9,4.12,4.12,0,0,1-1.53-4.81l1.07-3a4.17,4.17,0,0,0-2.53-5.34l-4.68-1.67a4.18,4.18,0,0,0-5.34,2.54l-1.38,3.89a4.25,4.25,0,0,1-4,2.78,32.36,32.36,0,0,0-6.08.55,4.22,4.22,0,0,1-4.45-2l-2.83-4.77a4.19,4.19,0,0,0-5.73-1.46l-4.27,2.54a4.18,4.18,0,0,0-1.46,5.73l2.21,3.71a4.16,4.16,0,0,1-.65,5.09,33.31,33.31,0,0,0-3.57,4.1,4.13,4.13,0,0,1-4.72,1.39L169.33,296a4.18,4.18,0,0,0-5.33,2.54l-1.67,4.68a4.19,4.19,0,0,0,2.54,5.34l3.39,1.21a4.15,4.15,0,0,1,2.8,4.08,34.83,34.83,0,0,0,.06,4.09,4.17,4.17,0,0,1-3,4.27l-2.81.85a4.18,4.18,0,0,0-2.79,5.21L164,333a4.18,4.18,0,0,0,5.21,2.79l4.34-1.32a4.23,4.23,0,0,1,4.56,1.5,32.79,32.79,0,0,0,5.19,5.28,4.24,4.24,0,0,1,1.38,4.7l-1.39,3.89a4.18,4.18,0,0,0,2.54,5.34l4.67,1.67a4.18,4.18,0,0,0,5.34-2.54l1.08-3a4.13,4.13,0,0,1,4.23-2.77,32.37,32.37,0,0,0,7.5-.16,4.21,4.21,0,0,1,4.34,2.41l1.84,3.86a4.17,4.17,0,0,0,5.57,2l4.48-2.13a4.17,4.17,0,0,0,2-5.57l-1.72-3.61a4.15,4.15,0,0,1,1-4.89,32.91,32.91,0,0,0,4.85-5.28,4.13,4.13,0,0,1,4.72-1.39L239.1,335a4.18,4.18,0,0,0,5.34-2.54l1.67-4.68A4.19,4.19,0,0,0,243.57,322.4Zm-22.19-1.1a18.17,18.17,0,1,1-11-23.21A18.17,18.17,0,0,1,221.38,321.3Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 502.49,
    cy: 138.59,
    r: 11.03,
    transform: "translate(47.68 396.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 427.11,
    cy: 164.99,
    r: 11.03,
    transform: "translate(167.22 543.48) rotate(-76.77)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "500.99 140.08 427.62 163.85 343.46 217.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 475.67,
    y: 170.64,
    width: 52.33,
    height: 317.41,
    rx: 8.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 403.93,
    y: 218.36,
    width: 52.33,
    height: 271.26,
    rx: 8.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 334.12,
    y: 261.56,
    width: 52.33,
    height: 227.17,
    rx: 8.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.19,287.83a193.13,193.13,0,0,0-129.26,55.81,5.48,5.48,0,0,0,.12,7.9l80.74,75a5.42,5.42,0,0,0,7.23.17c11.69-10.13,26.73-16.25,43.09-17.76a5.41,5.41,0,0,0,5-5.36V294.51A6.68,6.68,0,0,0,290.19,287.83Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.79,487.76h111.3a5.47,5.47,0,0,0,5.45-5.19c1.06-17.51,5.6-30.94,15.92-43.4a5.44,5.44,0,0,0-.54-7.43l-80-74.13a5.48,5.48,0,0,0-7.78.35A193,193,0,0,0,98.32,482.13,5.48,5.48,0,0,0,103.79,487.76Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304,293.26V403.55a5.49,5.49,0,0,0,5,5.44,77.2,77.2,0,0,1,43.07,17.92,5.45,5.45,0,0,0,7.21-.23l80.8-75.07a5.46,5.46,0,0,0,.13-7.89,193.18,193.18,0,0,0-130.59-55.93A5.48,5.48,0,0,0,304,293.26Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M502,482.09A193,193,0,0,0,452.19,358a5.47,5.47,0,0,0-7.79-.35l-79.92,74.26a5.44,5.44,0,0,0-.61,7.33c10.52,13.55,14.1,24.52,16,43.57a5.46,5.46,0,0,0,5.43,4.9H496.5A5.48,5.48,0,0,0,502,482.09Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.93,414.83a72.93,72.93,0,0,0-72.69,67,5.48,5.48,0,0,0,5.45,5.93H367.16a5.49,5.49,0,0,0,5.46-5.93A72.94,72.94,0,0,0,299.93,414.83Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308,449.21a12.65,12.65,0,0,0-11.56-6.06l-36.67-64.59a5.2,5.2,0,0,0-.62-.88L229.69,343.6a.68.68,0,0,0-1.15.71l16.71,41.55a5.09,5.09,0,0,0,.46.9L286,450a12.62,12.62,0,1,0,22-.74Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-8",
    points: "485.5 470.75 485.8 480.15 495.79 478.49 495.75 470.7 485.5 470.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M497.29,478c-10.33-.16-13.72-.17-26.68,6.34a1.94,1.94,0,0,0,1,3.63l23.82-.12C498.85,488,497.29,478,497.29,478Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-8",
    points: "531.76 470.12 532 479.54 542.02 480.31 541.98 470.66 531.76 470.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-10",
    d: "M538.06,478c-1.3,0-5.45.28-7.6,2.42-2.78,2.75-2.41,7.53-1.28,7.53l17.67.06c.85.06.57-4.12-1.4-6.78C543.67,478.78,542.19,477.93,538.06,478Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M535.07,353.66c1.06,7.25,5.67,40.32,5.16,66.21a1,1,0,0,0,0,.24l6,51.59a1.82,1.82,0,0,1-1.81,2H532.71a1.82,1.82,0,0,1-1.77-1.41c-2-8.76-12.9-55.66-13.71-61.89-.89-6.86-1.79-16.12-1.79-16.12L508,424.7a.69.69,0,0,0,0,.13l-8.28,48.06a1.83,1.83,0,0,1-1.82,1.51l-12.31-.2a1.81,1.81,0,0,1-1.79-1.95l3.9-54.58c0-.05,0-.09,0-.14l9.9-66a1.82,1.82,0,0,1,1.92-1.55l33.88,2.19A1.81,1.81,0,0,1,535.07,353.66Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 513.96,
    y1: 394.81,
    x2: 509.32,
    y2: 357.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "510.96 391.9 500.97 424.67 494.19 470.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "531.35 368.64 534.66 420.14 541.46 470.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M505.78,360.17s1.77,12.46,6.68,12.29",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M523.65,357.47a40.35,40.35,0,0,0,7.66,15",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M534.19,327.32c0-.65-.43-6.21.21-6.25l10.26,1.43c.41-5.46-1.4-31.5-14.57-32.84-9.39-1-14.06-.3-21.43,0a17.29,17.29,0,0,0-13.38,7.23c-3.86,5.41-8.71,13.1-10.24,19.27-2.28,9.17,7.68,13.26,10.62,14.25a1.16,1.16,0,0,1,.8,1.11l.08,20.54a1.82,1.82,0,0,0,1.84,1.81l35.77-.35a1.19,1.19,0,0,0,1.11-1.23Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M509.46,286.38l0,4.16a7.56,7.56,0,0,0,7.55,6c6.57.17,7.12-7,7.12-7l-2-6.39V276.1l2.56-10.83L497.84,256s-1.66,15.89,0,21.45S503.71,288.61,509.46,286.38Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M497.18,260.22s10-2.8,12.78,3.88,2.65,5.16,3.81,3.88,5.16-.9,4.71,2.61c-.58,4.46-1.57,8.19,3.67,12.59a23.37,23.37,0,0,1,3.77-12.27c3.88-5.69,3.34-18.51-9.62-20.64s-6-5.15-16.25-3.56S490.48,259.65,497.18,260.22Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 500.59,
    y1: 304.93,
    x2: 497.83,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M470.75,306.2l26.77-1.77a1.27,1.27,0,0,1,1.31.93l11.75,41.94a1.28,1.28,0,0,1-1.15,1.62l-26.81,1.61a1.27,1.27,0,0,1-1.31-.93L469.6,307.81A1.28,1.28,0,0,1,470.75,306.2Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M533.06,316.79l.46,7.23-26,.55s-.75-3.85-2.88-5.66-3.07-1.67-3.2-1,2.07,3.19,1.57,4.44c-.22,3.14-10.44-5-10.86-2.95-.92.73.89,2.65.89,2.65-1.1.09-2.15,2-.76,2.69-1.15.35-1.09,2.7.09,3-2.81,2.64,7,8.89,14.44,4,0,0,31.47,4.53,34,2.37s2.58-14.23,2.58-14.23Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M530.11,298.86l1.52,21.77,13,1.87c.47.05-1.16-3.77-1.3-4.22l-2-4.4Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M472.25,327.91c-.48-1.53-.54-3.8.95-4.67,2.94-1.71,3.64-2.43,4.67-1.85s0,2.08,0,2.08c1.11-.05,2.37,1.69,1.08,2.57,1.18.22,1.41,2.55.26,3,1.67,1.22-.13,4-3.75,4.27C473,333.46,472.66,329.2,472.25,327.91Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 532.02,
    y1: 324.25,
    x2: 528.61,
    y2: 305.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 499.62,
    y1: 351.03,
    x2: 529.81,
    y2: 350.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M140.63,445.94l-4.17-1.48a5,5,0,0,1-3.39-4.95,39.67,39.67,0,0,0-.5-8.66,5,5,0,0,1,2.85-5.36l4.37-2.08a5.1,5.1,0,0,0,2.42-6.79l-2.6-5.46a5.1,5.1,0,0,0-6.79-2.42l-4.62,2.2a5.16,5.16,0,0,1-6-1.07,40.16,40.16,0,0,0-7-6,5.05,5.05,0,0,1-1.87-5.88l1.31-3.68a5.09,5.09,0,0,0-3.09-6.51l-5.7-2a5.1,5.1,0,0,0-6.51,3.09l-1.69,4.75A5.15,5.15,0,0,1,92.75,397a40.69,40.69,0,0,0-7.41.68,5.16,5.16,0,0,1-5.42-2.39l-3.46-5.81a5.09,5.09,0,0,0-7-1.78l-5.2,3.09a5.09,5.09,0,0,0-1.78,7l2.69,4.53a5.05,5.05,0,0,1-.79,6.2,40,40,0,0,0-4.35,5,5,5,0,0,1-5.75,1.7l-4.17-1.49a5.1,5.1,0,0,0-6.51,3.1l-2,5.7a5.09,5.09,0,0,0,3.09,6.5l4.14,1.48a5.06,5.06,0,0,1,3.42,5,39.68,39.68,0,0,0,.06,5,5.06,5.06,0,0,1-3.6,5.2l-3.42,1a5.09,5.09,0,0,0-3.4,6.36l1.75,5.79a5.11,5.11,0,0,0,6.36,3.4l5.29-1.61a5.15,5.15,0,0,1,5.55,1.83,41,41,0,0,0,6.33,6.44,5.13,5.13,0,0,1,1.68,5.72l-1.69,4.75a5.1,5.1,0,0,0,3.09,6.51l5.7,2a5.09,5.09,0,0,0,6.51-3.09l1.31-3.68a5,5,0,0,1,5.16-3.38,39.91,39.91,0,0,0,9.15-.2,5.15,5.15,0,0,1,5.3,2.94l2.23,4.71a5.1,5.1,0,0,0,6.79,2.41l5.47-2.59a5.1,5.1,0,0,0,2.41-6.79l-2.09-4.41a5,5,0,0,1,1.18-6,40.72,40.72,0,0,0,5.91-6.44,5,5,0,0,1,5.75-1.69l4.16,1.48a5.09,5.09,0,0,0,6.51-3.09l2-5.7A5.1,5.1,0,0,0,140.63,445.94Zm-27-1.35a22.15,22.15,0,1,1-13.44-28.3A22.14,22.14,0,0,1,113.58,444.59Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M204.25,466.49l-2.33-1.15a3,3,0,0,1-1.65-3.11,24.31,24.31,0,0,0,.29-5.1,3,3,0,0,1,2-2.94l2.69-.92a3,3,0,0,0,1.87-3.81L206,446.1a3,3,0,0,0-3.81-1.87l-2.85,1a3,3,0,0,1-3.42-1,23.34,23.34,0,0,0-3.69-3.95,3,3,0,0,1-.7-3.56l1-2.06a3,3,0,0,0-1.38-4L188,429a3,3,0,0,0-4,1.37l-1.3,2.66a3,3,0,0,1-3.1,1.65,23.79,23.79,0,0,0-4.38-.1,3,3,0,0,1-3-1.76l-1.63-3.63a3,3,0,0,0-4-1.5l-3.24,1.45a3,3,0,0,0-1.51,4L163.1,436a3,3,0,0,1-.88,3.57,23.74,23.74,0,0,0-2.87,2.63,3,3,0,0,1-3.47.61l-2.34-1.15a3,3,0,0,0-4,1.37l-1.56,3.2a3,3,0,0,0,1.37,4l2.32,1.14a3,3,0,0,1,1.66,3.14,23.88,23.88,0,0,0-.3,2.92,3,3,0,0,1-2.45,2.79l-2.07.38a3,3,0,0,0-2.41,3.49l.64,3.5a3,3,0,0,0,3.49,2.41l3.19-.59a3.06,3.06,0,0,1,3.13,1.44A23.82,23.82,0,0,0,159.8,475a3,3,0,0,1,.6,3.45l-1.3,2.66a3,3,0,0,0,1.37,4l3.19,1.57a3,3,0,0,0,4-1.37l1-2.07a3,3,0,0,1,3.24-1.62,23.73,23.73,0,0,0,5.36.49,3,3,0,0,1,2.89,2.07l1,2.9A3,3,0,0,0,185,489l3.37-1.15A3,3,0,0,0,190.2,484l-.93-2.71a3,3,0,0,1,1.09-3.41,23.28,23.28,0,0,0,3.88-3.36,3,3,0,0,1,3.47-.6l2.34,1.14a3,3,0,0,0,4-1.37l1.56-3.19A3,3,0,0,0,204.25,466.49Zm-15.71-2.6a13,13,0,1,1-6-17.43A13,13,0,0,1,188.54,463.89Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    className: "cls-5",
    cx: 204.31,
    cy: 214.19,
    r: 35.9,
    transform: "translate(-67.1 93.17) rotate(-22.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-2",
    "data-name": "Ellipse",
    className: "cls-13",
    cx: 204.31,
    cy: 214.19,
    r: 39.76,
    transform: "translate(-71.61 103.73) rotate(-24.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M195.43,216.76,188.9,233.4a.6.6,0,0,0,.84.74l5-2.76a.6.6,0,0,1,.86.34l1.7,5.39a.6.6,0,0,0,1.12,0l5.89-14.92a.58.58,0,0,0-.23-.72l-7.73-5A.59.59,0,0,0,195.43,216.76Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M213.2,217.5l6.53,16.64a.6.6,0,0,1-.85.74l-5-2.76a.59.59,0,0,0-.85.34l-1.7,5.39a.59.59,0,0,1-1.12,0L204.35,223a.62.62,0,0,1,.23-.72l7.74-5A.6.6,0,0,1,213.2,217.5Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 202.81,
    cy: 208.24,
    r: 17.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M212.64,207.74a8.33,8.33,0,1,1-8.33-8.32A8.33,8.33,0,0,1,212.64,207.74Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.77,210.83a.68.68,0,0,1-1.06-.18l-1.31-2.48a.66.66,0,0,1,1.17-.62l.92,1.73,4.7-4.35a.66.66,0,1,1,.9,1Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-3",
    "data-name": "Ellipse",
    className: "cls-5",
    cx: 99.47,
    cy: 284.92,
    r: 35.9,
    transform: "translate(-101.44 58.9) rotate(-22.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-4",
    "data-name": "Ellipse",
    className: "cls-13",
    cx: 99.47,
    cy: 284.92,
    r: 39.76,
    transform: "translate(-84.62 45.14) rotate(-17.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M79.46,287.73a17.73,17.73,0,0,0,16.26,16.18,1.29,1.29,0,0,0,1.4-1.29v-15a1.28,1.28,0,0,0-1.28-1.29H80.75A1.3,1.3,0,0,0,79.46,287.73Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M99.47,287.61v15a1.3,1.3,0,0,0,1.4,1.29,17.73,17.73,0,0,0,16.26-16.18,1.29,1.29,0,0,0-1.28-1.41H100.76A1.29,1.29,0,0,0,99.47,287.61Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M119.31,279.79a17.74,17.74,0,0,0-16.26-16.19,1.31,1.31,0,0,0-1.4,1.29v15a1.28,1.28,0,0,0,1.29,1.28H118A1.29,1.29,0,0,0,119.31,279.79Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M97.12,282.85v-15a1.29,1.29,0,0,0-1.4-1.29,17.73,17.73,0,0,0-16.26,16.18,1.3,1.3,0,0,0,1.29,1.41H95.84A1.28,1.28,0,0,0,97.12,282.85Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-5",
    "data-name": "Ellipse",
    className: "cls-5",
    cx: 334.24,
    cy: 204.75,
    r: 35.9,
    transform: "translate(-53.99 141.38) rotate(-22.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-6",
    "data-name": "Ellipse",
    className: "cls-13",
    cx: 334.24,
    cy: 204.75,
    r: 39.76,
    transform: "translate(-53.94 141.1) rotate(-22.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M310.06,206.09h16.4a.21.21,0,0,1,.21.21c0,1.28-.32,8-8.43,8s-8.42-6.67-8.43-8A.24.24,0,0,1,310.06,206.09Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M310.39,205.57l7.69-14.73a.12.12,0,0,1,.22,0L326,205.58a.35.35,0,0,1-.29.51h-15A.35.35,0,0,1,310.39,205.57Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M344.37,224.85H324a.6.6,0,0,1-.53-.9l1.89-3.49a1.59,1.59,0,0,1,1.39-.83h14.67a1.56,1.56,0,0,1,1.36.78l2.11,3.55A.59.59,0,0,1,344.37,224.85Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 331.22,
    y: 186.81,
    width: 2.9,
    height: 33.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M337.57,188a3.4,3.4,0,1,1-3.4-3.4A3.4,3.4,0,0,1,337.57,188Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M318.33,190.84s10,.19,13.37-3.2",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M358.37,206.09H342.11a.3.3,0,0,0-.3.29c0,1.47.48,8,8.43,8s8.41-6.49,8.43-8A.29.29,0,0,0,358.37,206.09Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M358,205.58l-7.44-14.37a.34.34,0,0,0-.61,0l-7.44,14.37a.35.35,0,0,0,.29.51h14.91A.35.35,0,0,0,358,205.58Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M350.24,191s-10.14,0-13.54-3.38",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 43.65,
    y1: 488.73,
    x2: 555.65,
    y2: 488.73
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    width: 600,
    height: 600
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalable);
export default __webpack_public_path__ + "static/media/scalable.b32553d446b68e843959094b081d366a.svg";
export { ForwardRef as ReactComponent };